var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "600" } },
    [
      _c("w-card-title", [_vm._v(" Filters toepassen "), _c("w-spacer")], 1),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            { attrs: { "no-margin": "" } },
            [
              _c(
                "w-col",
                { attrs: { md: "6", sm: "12" } },
                [
                  _c("app-department-select", {
                    staticClass: "department mr",
                    attrs: { label: "Afdeling", multi: "" },
                    model: {
                      value: _vm.quickFilters.departmentIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.quickFilters, "departmentIds", $$v)
                      },
                      expression: "quickFilters.departmentIds",
                    },
                  }),
                  _c("w-select", {
                    staticClass: "read mr mt",
                    attrs: { items: _vm.readItems, label: "Gelezen" },
                    model: {
                      value: _vm.quickFilters.read,
                      callback: function ($$v) {
                        _vm.$set(_vm.quickFilters, "read", $$v)
                      },
                      expression: "quickFilters.read",
                    },
                  }),
                  _c("w-select", {
                    staticClass: "read mr mt",
                    attrs: { items: _vm.plannedStatusItems, label: "Planning" },
                    model: {
                      value: _vm.quickFilters.plannedStatus,
                      callback: function ($$v) {
                        _vm.$set(_vm.quickFilters, "plannedStatus", $$v)
                      },
                      expression: "quickFilters.plannedStatus",
                    },
                  }),
                  _c("w-select", {
                    staticClass: "read mr mt",
                    attrs: {
                      items: _vm.attentionGivenItems,
                      label: "Attentie gegeven",
                    },
                    model: {
                      value: _vm.quickFilters.attentionGiven,
                      callback: function ($$v) {
                        _vm.$set(_vm.quickFilters, "attentionGiven", $$v)
                      },
                      expression: "quickFilters.attentionGiven",
                    },
                  }),
                  _c("w-multi-select", {
                    staticClass: "read mr mt",
                    attrs: {
                      "empty-text": "Geen gekozen",
                      items: _vm.tierItems,
                      label: "Winfakt versie",
                    },
                    model: {
                      value: _vm.quickFilters.tierIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.quickFilters, "tierIds", $$v)
                      },
                      expression: "quickFilters.tierIds",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { md: "6", sm: "12" } },
                [
                  _c("app-ticket-status-select", {
                    staticClass: "status mr",
                    attrs: { label: "Status", multi: "" },
                    model: {
                      value: _vm.quickFilters.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.quickFilters, "status", $$v)
                      },
                      expression: "quickFilters.status",
                    },
                  }),
                  _c("app-company-employee-select", {
                    staticClass: "employee-account mr mt",
                    attrs: { "use-undefined": "" },
                    model: {
                      value: _vm.quickFilters.employeeAccount,
                      callback: function ($$v) {
                        _vm.$set(_vm.quickFilters, "employeeAccount", $$v)
                      },
                      expression: "quickFilters.employeeAccount",
                    },
                  }),
                  _c("w-select", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.demoToolTip,
                        expression: "demoToolTip",
                      },
                    ],
                    staticClass: "read mr mt",
                    attrs: { items: _vm.demoItems, label: "Demo" },
                    model: {
                      value: _vm.quickFilters.demo,
                      callback: function ($$v) {
                        _vm.$set(_vm.quickFilters, "demo", $$v)
                      },
                      expression: "quickFilters.demo",
                    },
                  }),
                  _c("w-select", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.freeToolTip,
                        expression: "freeToolTip",
                      },
                    ],
                    staticClass: "read mr mt",
                    attrs: { items: _vm.freeItems, label: "Free" },
                    model: {
                      value: _vm.quickFilters.free,
                      callback: function ($$v) {
                        _vm.$set(_vm.quickFilters, "free", $$v)
                      },
                      expression: "quickFilters.free",
                    },
                  }),
                  _c(
                    "w-date-picker",
                    {
                      staticClass: "read mr mt",
                      attrs: { label: "Ticket aanmaak datum", nullable: "" },
                      model: {
                        value: _vm.quickFilters.timeCreated,
                        callback: function ($$v) {
                          _vm.$set(_vm.quickFilters, "timeCreated", $$v)
                        },
                        expression: "quickFilters.timeCreated",
                      },
                    },
                    [_vm._v(" /> ")]
                  ),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-multi-select", {
                    attrs: {
                      items: _vm.adminItems,
                      label: "Attentie aan mij van",
                    },
                    model: {
                      value: _vm.quickFilters.attentionFromAdminIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.quickFilters, "attentionFromAdminIds", $$v)
                      },
                      expression: "quickFilters.attentionFromAdminIds",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v("Annuleren")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v("Filters toepassen")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }